export const REWARDPOINT_RESET_STATE = 'REWARDPOINT_RESET_STATE';
export const REWARDPOINT_CURRENT_ITEM = 'REWARDPOINT_CURRENT_ITEM';

export const REWARDPOINT_REQUEST_LOADING = 'REWARDPOINT_REQUEST_LOADING';
export const REWARDPOINT_REQUEST_SUCCESS = 'REWARDPOINT_REQUEST_SUCCESS';
export const REWARDPOINT_REQUEST_FAILED = 'REWARDPOINT_REQUEST_FAILED';

export const REWARDPOINT_CURRENT_ACTION = 'REWARDPOINT_CURRENT_ACTION';
export const REWARDPOINT_RESET_ACTION = 'REWARDPOINT_RESET_ACTION';